export const postalCodeFormat =
  /^[ABCEGHJKLMNPRSTVXY]\d[A-Z]{1} *\d[A-Z]\d$|^\d{5}$/g;
